import { IonButton, IonLabel, IonModal } from "@ionic/react";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "./SBoardTimer.scss";

interface ContainerProps {
  showModal: boolean;
  onCancel: () => void;
}

const SBoardTimer: React.FC<ContainerProps> = (props) => {
  const { t } = useTranslation("statusBoard");
  const [time, setTime] = useState({ ms: 0, s: 0, m: 0, h: 0 });
  const [interv, setIntervalTimer] = useState();
  const [status, setStatus] = useState(0);

  var updatedMs = time.ms,
    updatedS = time.s,
    updatedM = time.m,
    updatedH = time.h;

  const start = () => {
    run();
    setStatus(1);

    const myIntervalID: any = setInterval(run, 1000);
    setIntervalTimer(myIntervalID);
  }
  const run = () => {
    if (updatedM === 60) {
      updatedH++;
      updatedM = 0;
    }
    if (updatedS === 60) {
      updatedM++;
      updatedS = 0;
    }
    updatedS++;
    return setTime({ ms: updatedMs, s: updatedS, m: updatedM, h: updatedH });
  };

  const stop = () => {
    setStatus(2);
    clearInterval(interv);

  };

  const reset = () => {
    setTime({ ms: 0, s: 0, m: 0, h: 0 });
    clearInterval(interv);
    setStatus(0);
  };

  const h = () => {
    if (time.h === 0) {
      return "";
    } else {
      return <span>{time.h >= 10 ? time.h : "0" + time.h}</span>;
    }
  };

  const onCloseModalClick = () => {
    props.onCancel();
    setTime({ ms: 0, s: 0, m: 0, h: 0 });
    clearInterval(interv);
    setStatus(0);
  }
  return (
    <IonModal
      isOpen={props.showModal}
      backdropDismiss={false}
      className="timer-modal"
    >
      <div className="timer-header">
        <IonLabel className="timer">{t("timer")}</IonLabel>

        <div>
          <IonLabel
            className="close icon-close"
            onClick={
              onCloseModalClick}
          ></IonLabel>
        </div>
      </div>
      {/* <IonItem> */}
      <div className="stopwatch">
        {h()}&nbsp;&nbsp;
        <span>{time.h >= 10 ? time.h : "0" + time.h}</span>&nbsp;:&nbsp;
        <span>{time.m >= 10 ? time.m : "0" + time.m}</span>&nbsp;:&nbsp;
        <span>{time.s >= 10 ? time.s : "0" + time.s}</span>&nbsp;&nbsp;
      </div>
      {/* </IonItem> */}
      <div className="buttons-div">
        {status === 0 ? (
          <IonButton
            className="start-btn primary-btn btn-curved"
            onClick={() => start()}
          >
            {t("start")}
          </IonButton>
        ) : (
          ""
        )}
        {status === 1 ? (
          <IonButton
            className="stop-btn  primary-btn btn-curved"
            onClick={() => stop()}
          >
             {t("stop")}
          </IonButton>
        ) : (
          ""
        )}
        {status === 2 ? (
          <IonButton
            className="reset-btn  primary-btn btn-curved"
            onClick={() => reset()}
          >
            {t("reset")}
          </IonButton>
        ) : (
          ""
        )}
      </div>
    </IonModal>
  );
};

export default SBoardTimer;
